import {
    PlatformEyebrow,
    platformContainer,
    platformHeroBg,
    platformHeroLayout,
    platformHeroTitleClass,
} from '../PlatformShared'

export default function PricingHero({ data, billing, onBillingChange }) {
    return (
        <section className={`${platformHeroBg} text-center`}>
            <div
                className={`${platformContainer} ${platformHeroLayout} flex flex-col justify-center`}>
                <PlatformEyebrow align="center">{data.label}</PlatformEyebrow>
                <h1
                    className={`mx-auto max-w-[900px] ${platformHeroTitleClass}`}>
                    {data.title}{' '}
                    <span className="bg-rtl-gradient bg-clip-text text-transparent">
                        {data.accent}
                    </span>
                </h1>
                <p className="mx-auto mb-7 mt-[22px] max-w-[860px] text-base leading-relaxed text-olm-gray sm:text-[17px]">
                    {data.description}
                </p>
                <div
                    role="group"
                    aria-label="Billing frequency"
                    className="inline-flex w-fit max-w-full self-center rounded-full border border-black/10 bg-white p-1 shadow-sm">
                    {data.billing.map((option) => (
                        <button
                            key={option.id}
                            type="button"
                            aria-pressed={billing === option.id}
                            onClick={() => onBillingChange(option.id)}
                            className={`flex items-center gap-2 rounded-full px-4 py-2.5 text-[13px] font-bold focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary sm:px-5 ${
                                billing === option.id
                                    ? 'bg-[#1A1D23] text-white'
                                    : 'text-olm-gray'
                            }`}>
                            {option.label}
                            {option.badge && (
                                <span
                                    className={`rounded-full px-2 py-0.5 text-[10px] font-extrabold ${
                                        billing === option.id
                                            ? 'bg-white/20 text-white'
                                            : 'bg-green-100 text-green-700'
                                    }`}>
                                    {option.badge}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </section>
    )
}
